import type { NextPage } from 'next'

import { PAGE_OPTIONS } from '../../lib/utils/page'
import { PageTemplate } from '../../page-templates/generic-page'

const InvestingFail: NextPage = () => (
    <PageTemplate {...PAGE_OPTIONS.SCHOOL_REQUEST_WAITLIST_FAIL} />
)

export default InvestingFail
